<template>
    <div>
        <div class="content-caption dashed">
            <span>合同信息</span>
        </div>
        <div class="simple-form flex col-3">
            <div class="form-group center">
                <div class="form-label">
                    <label :class="normalFlag ? 'required' : ''">税率(%)</label>
                </div>
                <div class="form-value width-2x">
                    <el-select v-if="normalFlag" v-model="contract.taxRate" filterable placeholder="请选择税率" @change="taxRateChange(contract.taxRate)">
                        <el-option v-for="item in fiscalTaxMarkList" :key="item.rate" :label="item.rate" :value="item.rate"></el-option>
                    </el-select>
                    <el-input v-if="!normalFlag" class="width-2x" v-model="contract.taxRate" @change="taxRateChange(contract.taxRate)"></el-input>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>启用区域价格</label>
                </div>
                <div class="form-value width-2x">
                    <el-checkbox v-model="contract.bizAreaFlag" @change="bizAreaFlagChange(null);"></el-checkbox>
                </div>
            </div>
            <div class="form-group center" v-if="contract.typeId == goodsPurch.value">
                <div class="form-label">
                    <label>是否自动结算</label>
                </div>
                <div class="form-value width-2x">
                    <el-radio-group v-model="contract.settleAutoFlag">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="form-group center" v-if="contract.typeId == goodsPurch.value && contract.settleAutoFlag">
                <div class="form-label">
                    <label>结算周期(每月x日)</label>
                </div>
                <div class="form-value width-2x">
                    <el-input-number v-model="contract.settlePeriodDay" :controls="false" :min="1" :max="28"></el-input-number>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>发票信息</span>
            <span class="swb-btn swb-btn-link" @click="selectInvoiceSubject">常用发票</span>
        </div>
        <div class="simple-form flex col-2">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">发票类型</label>
                </div>
                <div class="form-value width-2x">
                    <ul class="enum-list">
                        <li class="enum-item" :class="{checked : (merchantInvoiceType.value == contract.invoiceType)}" v-for="merchantInvoiceType in invoiceTypeList" @click="checkInvoiceType(merchantInvoiceType.value)">
                            {{ merchantInvoiceType.text }}<i></i>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>发票抬头</label>
                </div>
                <div class="form-value width-2x">
                    <el-input v-model="contract.invoiceTitle"></el-input>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>发票内容标签</label>
                </div>
                <div class="form-value width-2x mt5">
                    <ul class="enum-list">
                        <li class="enum-item" v-bind:class="{checked : invoiceContentTag.name == contract.invoiceContentTag}" v-for="invoiceContentTag in invoiceContentTagList" @click="checkinvoiceContentTag(invoiceContentTag.name)">
                            {{ invoiceContentTag.name }}<i></i>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">纳税人识别号</label>
                </div>
                <div class="form-value width-2x">
                    <el-input v-model="contract.taxPayerNo"></el-input>
                </div>
            </div>
        </div>

        <div class="content-caption dashed">
            <span>商品信息</span>
        </div>
        <div class="simple-row">
            <div class="left">
                <button @click="showMkuListDlg" class="swb-btn swb-btn-small" v-if="!showAssetInfo"><span>选择商品</span></button>

                <button @click="showDevcDefListDlg" class="swb-btn swb-btn-small" v-if="showAssetInfo"><span>选择资产定义</span></button>

                <button @click="showAsmblAccListDlg" class="swb-btn swb-btn-small" v-if="showAssetInfo"><span>选择组装件定义</span></button>
            </div>
            <div class="right">
                <button class="swb-btn swb-btn-small swb-btn-primary" @click="setBizFormBatch()">批量设置经营业态</button>
            </div>
        </div>
        <div class="table-layout">
            <el-form :model="contract" ref="contractGoodsList">
                <el-table ref="multipleTable" :data="contract.contractGoodsList" border tooltip-effect="dark" maxHeight="500" style="width: 100%" @selection-change="handleSelectionChange" v-if="!showAssetInfo">
                    <el-table-column type="selection" width="40" align="center" fixed="left"></el-table-column>
                    <el-table-column align="left" prop="name" label="商品名称"></el-table-column>
                    <el-table-column align="left" prop="catName" label="分类"></el-table-column>
                    <el-table-column align="left" width="100px" prop="brandName" label="品牌"></el-table-column>
                    <el-table-column align="left" prop="model" label="型号"></el-table-column>
                    <el-table-column align="left" prop="fixedSpec" label="规格"></el-table-column>
                    <el-table-column align="center" width="60" prop="asmblAccFlag" label="组装件">
                        <template slot-scope="scope">
                            <el-form-item :prop="'contractGoodsList.' + scope.$index + '.asmblAccFlag'">
                                <input type="checkbox" v-model="scope.row.asmblAccFlag" @change="setAsmblAcc(scope.row, scope.$index)"/>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="190" prop="asmblAccFlag" label="关联定义">
                        <template slot-scope="scope">
                            <span class="ellipsis" style="padding-right: 5px;display: inline-block;width: 95%;line-height: 1;" v-if="scope.row.assetDefId != null && scope.row.assetDefId != -1">{{ scope.row.assetDefNo }}</span>
                            <a class="swb-btn-link" v-if="scope.row.assetDefId == null || scope.row.assetDefId == -1" @click="selectDevcDef(scope.row, scope.$index)">选择</a>
                            <a class="swb-btn-link" v-if="scope.row.skuId > 0 && (scope.row.assetDefId == null || scope.row.assetDefId == -1)" @click="saveDevcDef(scope.row, scope.$index)">生成定义</a>
                            <a class="swb-btn-link" style="position: absolute;right: 2px;" @click="clearDevcDef(scope.row, scope.$index, true)">清除</a>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="80px" prop="quantity" label="数量" v-if="contract.kindId == 0">
                        <template slot-scope="scope">
                            <el-form-item :prop="'contractGoodsList.' + scope.$index + '.quantity'">
                                <el-input :maxlength="6" :disabled="scope.row.bizAreaFlag" type="text" @change="goodsAmountOrQuantityChange(scope.row, scope.$index, 'quantity');" v-model.number="scope.row.quantity"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="100" label="是否可定制">
                        <template slot-scope="scope">
                            <input type="checkbox" :disabled="scope.row.asmblAccFlag || !scope.row.customizable" v-model="scope.row.customized"/>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="60px" prop="unit" label="单位"></el-table-column>
                    <el-table-column align="center" width="100px" prop="price" label="统一含税价(元)">
                        <template slot-scope="scope">
                            <el-form-item :prop="'contractGoodsList.' + scope.$index + '.price'">
                                <el-input v-if="checkActionPerm('view_item_price')" :maxlength="9" type="text" @change="goodsAmountOrQuantityChange(scope.row, scope.$index, 'price');" v-model="scope.row.price"></el-input>
                                <el-input v-else disabled type="text" value="没有权限"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" width="80" label="税率(%)">
                        <template slot-scope="scope">
                            <span v-if="checkActionPerm('view_item_price')">{{ scope.row.taxRate }}</span>
                            <span v-else>没有权限</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="80" prop="taxOffset" label="购置可抵税">
                        <template slot-scope="scope">
                            <span v-if="scope.row.taxOffset">是</span>
                            <span v-else>否</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" width="100px" prop="ntxPrice" label="未税价(元)">
                        <template slot-scope="scope">
                            <div v-if="checkActionPerm('view_item_price')">
                                <span v-if="scope.row.ntxPrice != null">{{ scope.row.ntxPrice }}</span>
                                <span v-else>0.00</span>
                            </div>
                            <div v-else>
                                <span>没有权限</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" width="100px" prop="bizFormNames" label="经营业态">
                        <template slot-scope="scope">
                            <div v-if="scope.row.bizFormNameList != null && scope.row.bizFormNameList.length > 0" v-for="(bizFormName, index) in scope.row.bizFormNameList">
                                <span class="swb-tags swb-tags-success mr5">{{ bizFormName }}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="90" label="启用区域价格">
                        <template slot-scope="scope">
                            <input v-if="checkActionPerm('view_item_price')" type="checkbox" v-model="scope.row.bizAreaFlag"
                                   @change="bizAreaFlagChange(scope.$index)"/>
                            <span v-else>没有权限</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" width="100px" prop="amount" label="含税小计(元)" v-if="contract.kindId == 0">
                        <template slot-scope="scope">
                            <div v-if="checkActionPerm('view_item_price')">
                                <span v-if="scope.row.amount != null">{{ scope.row.amount }}</span>
                                <span v-else>0.00</span>
                            </div>
                            <div v-else>
                                <span>没有权限</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" width="90px" prop="wrntPeriod" label="质保期(月)">
                        <template slot-scope="scope">
                            <el-form-item :prop="'contractGoodsList.' + scope.$index + '.wrntPeriod'" :rules="{validator: inputWrntPeriod, trigger: 'blur'}">
                                <el-input type="text" v-model.number="scope.row.wrntPeriod"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" width="150px" prop="desc" label="说明">
                        <template slot-scope="scope">
                            <el-form-item :prop="'contractGoodsList.' + scope.$index + '.desc'">
                                <el-input type="textarea" v-model="scope.row.desc"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column class="fixed" align="left" width="250" label="操作" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <a class="swb-btn-link" @click="removeGoods(scope.$index)">移除</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_item_price') && scope.row.bizAreaFlag" @click="bizAreaOption(scope.row, scope.$index)">经营区域价格</a>
                            <a class="swb-btn-link" @click="setBizForm(scope.row, scope.$index)">设置经营业态</a>
                        </template>
                    </el-table-column>
                </el-table>
                <el-table ref="multipleTable" :data="contract.contractGoodsList" border tooltip-effect="dark" maxHeight="500" style="width: 100%" @selection-change="handleSelectionChange" v-if="showAssetInfo">
                    <el-table-column type="selection" width="40" align="center" fixed="left"></el-table-column>
                    <el-table-column align="center" label="资产信息">
                        <el-table-column width="180" align="left" prop="assetDefNo" label="定义编码" style="position: relative" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span class="ellipsis" style="padding-right: 5px;display: inline-block;line-height: 1;" v-if="scope.row.assetDefId != null && scope.row.assetDefId != -1">{{ scope.row.assetDefNo }}</span>
                                <a class="swb-btn-link" v-if="scope.row.assetDefId == null || scope.row.assetDefId == -1" @click="selectDevcDef(scope.row, scope.$index)">选择</a>
                                <a class="swb-btn-link" v-if="scope.row.skuId > 0 && (scope.row.assetDefId == null || scope.row.assetDefId == -1) && !needAudit" @click="saveDevcDef(scope.row, scope.$index)">生成定义</a>
                                <a class="swb-btn-link" style="position: absolute;right: 2px;" @click="clearDevcDef(scope.row, scope.$index, true)">清除</a>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" prop="devcName" label="名称" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" prop="devcCatName" label="分类" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" width="100px" prop="devcBrandName" label="品牌" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" prop="devcModel" label="型号" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" prop="devcFixedSpec" label="规格" show-overflow-tooltip></el-table-column>
                        <el-table-column align="center" width="60px" prop="devcUnit" label="单位"></el-table-column>
                    </el-table-column>
                    <el-table-column align="center" label="商品信息">
                        <el-table-column width="180" align="left" prop="name" label="名称" style="position: relative" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span v-if="scope.row.name != null && scope.row.name != ''" class="ellipsis" style="padding-right: 30px;display: inline-block;width: 100%;line-height: 1;">{{ scope.row.name }}</span>
                                <a class="swb-btn-link" style="position: absolute;right: 2px;" @click="selectAdoptedDevice(scope.row, scope.$index)">
                                    <span v-if="scope.row.name == null || scope.row.name == ''">选择</span>
                                    <span v-else>更换</span>
                                </a>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" prop="catName" label="分类" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" width="100px" prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" prop="model" label="型号" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" prop="fixedSpec" label="规格" show-overflow-tooltip></el-table-column>
                        <el-table-column align="center" width="60px" prop="unit" label="单位"></el-table-column>
                    </el-table-column>
                    <el-table-column align="center" width="80px" prop="quantity" label="数量" v-if="contract.kindId == 0">
                        <template slot-scope="scope">
                            <el-form-item :prop="'contractGoodsList.' + scope.$index + '.quantity'">
                                <el-input :maxlength="6" :disabled="scope.row.bizAreaFlag" type="text" @change="goodsAmountOrQuantityChange(scope.row, scope.$index, 'quantity');" v-model.number="scope.row.quantity"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="100" label="是否可定制">
                        <template slot-scope="scope">
                            <input type="checkbox" :disabled="scope.row.asmblAccFlag || !scope.row.customizable" v-model="scope.row.customized"/>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="100px" prop="price" label="统一含税价(元)">
                        <template slot-scope="scope">
                            <el-form-item :prop="'contractGoodsList.' + scope.$index + '.price'">
                                <el-input v-if="checkActionPerm('view_item_price')" :maxlength="9" type="text" @change="goodsAmountOrQuantityChange(scope.row, scope.$index, 'price');" v-model="scope.row.price"></el-input>
                                <el-input v-else disabled type="text" value="没有权限"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" width="80" label="税率(%)">
                        <template slot-scope="scope">
                            <span v-if="checkActionPerm('view_item_price')">{{ scope.row.taxRate }}</span>
                            <span v-else>没有权限</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="80" prop="taxOffset" label="购置可抵税">
                        <template slot-scope="scope">
                            <span v-if="scope.row.taxOffset">是</span>
                            <span v-else>否</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" width="100px" prop="ntxPrice" label="未税价(元)">
                        <template slot-scope="scope">
                            <div v-if="checkActionPerm('view_item_price')">
                                <span v-if="scope.row.ntxPrice != null">{{ scope.row.ntxPrice }}</span>
                                <span v-else>0.00</span>
                            </div>
                            <div v-else>
                                <span>没有权限</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" width="100px" prop="bizFormNames" label="经营业态">
                        <template slot-scope="scope">
                            <div v-if="scope.row.bizFormNameList != null && scope.row.bizFormNameList.length > 0" v-for="(bizFormName, index) in scope.row.bizFormNameList">
                                <span class="swb-tags swb-tags-success mr5">{{ bizFormName }}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="90" label="启用区域价格">
                        <template slot-scope="scope">
                            <input v-if="checkActionPerm('view_item_price')" type="checkbox" v-model="scope.row.bizAreaFlag" @change="bizAreaFlagChange(scope.$index)"/>
                            <span v-else>没有权限</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" width="100px" prop="amount" label="含税小计(元)" v-if="contract.kindId == 0">
                        <template slot-scope="scope">
                            <div v-if="checkActionPerm('view_item_price')">
                                <span v-if="scope.row.amount != null">{{ scope.row.amount }}</span>
                                <span v-else>0.00</span>
                            </div>
                            <div v-else>
                                <span>没有权限</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" width="90px" prop="wrntPeriod" label="质保期(月)">
                        <template slot-scope="scope">
                            <el-form-item :prop="'contractGoodsList.' + scope.$index + '.wrntPeriod'" :rules="{validator: inputWrntPeriod, trigger: 'blur'}" v-if="scope.row.skuId != null && scope.row.skuId != -1">
                                <el-input type="text" v-model.number="scope.row.wrntPeriod"></el-input>
                            </el-form-item>
                            <el-form-item :prop="'contractGoodsList.' + scope.$index + '.wrntPeriod'" v-else>
                                <el-input type="text" v-model.number="scope.row.wrntPeriod"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="60" prop="asmblAccFlag" label="组装件">
                        <template slot-scope="scope">
                            <el-form-item :prop="'contractGoodsList.' + scope.$index + '.asmblAccFlag'">
                                <input type="checkbox" v-model="scope.row.asmblAccFlag" @change="setAsmblAcc(scope.row, scope.$index)"/>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" width="150px" prop="desc" label="说明">
                        <template slot-scope="scope">
                            <el-form-item :prop="'contractGoodsList.' + scope.$index + '.desc'">
                                <el-input type="textarea" v-model="scope.row.desc"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column class="fixed" align="left" width="250" label="操作" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <a class="swb-btn-link" @click="removeGoods(scope.$index)">移除</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_item_price') && scope.row.bizAreaFlag" @click="bizAreaOption(scope.row, scope.$index)">经营区域价格</a>
                            <a class="swb-btn-link" @click="setBizForm(scope.row, scope.$index)">设置经营业态</a>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form>
        </div>
        <div class="simple-form flex col-5" v-if="contract.kindId != null && contract.kindId == 0">
            <div class="form-group center">
                <div class="form-label">
                    <label>预计合同总额</label>
                </div>
                <div class="form-value width-2x">
                    <input v-if="checkActionPerm('view_total_price')" disabled style="border:1px solid #DDDDDD; width: 100px; height: 30px;" v-model.number="contract.estmtAmount"/>
                    <input v-else disabled style="border:1px solid #DDDDDD; width: 65px; height: 30px;" value="没有权限"/><span>元</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>预计商品总数量</label>
                </div>
                <div class="form-value width-2x">
                    <input :disabled="true" style="border:1px solid #DDDDDD; width: 65px; height: 30px;" v-model.number="contract.estmtGoodsCount"/><span>件</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'
    import {getMerchantBizParam} from '../asset/assetMain'
    import {checkUserActionPerm} from '../index'
    import {openSkuListSelectDlg} from '../goods/selectDlg';
    import {showMerchtDevcDefSelectDlg, openDevcDefSaveDlg} from '../devcDef/showDlg'
    import {showAsmblAccDefSelectDlg, openAccDefSaveDlg} from '../asmblAcc/dialog'
    import {openContractGoodsAreaPriceDlg} from './dialog'
    import {openBizFormSelectionDlg} from '../bizForm/selectDlg'
    import {goodsInSelectDlg} from '../retailer/dialog'
    import {selectInvoiceSubjectDlg} from '../invoiceVoucher/selectDlg';
    //
    import contractApi from '../../api/contract'
    import asmblAccApi from '../../api/asmblAcc'
    import devcDefApi from '../../api/devcDef'
    import fiscalBizApi from '../../api/fiscalBiz';
    import merchtComnApi from '../../api/merchtComn';
    import merchtFinacApi from '../../api/merchtFinac';

    import SwbGoodsPurchContractList from './GoodsPurchContractList';
    Routes.add(SwbGoodsPurchContractList);

    export default {
        name: 'swb-contract-modify',
        desc: '合同 - 修订',
        props: {
            id: {
                type: Number,
                default: null
            }
        },
        watch: {
            'contract.taxRate'(newVal, oldVal) {
                this.contract.taxRate = this.filterListValue(this.fiscalTaxMarkList, newVal)
            }
        },
        data: function () {
            return {
                contract: {
                    contractGoodsList: [],
                },
                dbContract: {},
                //
                goodsPurch: getEnumInfoWith("contractType", 'name', 'GoodsPurch'),
                showAssetInfo: false,
                needAudit: false,
                normalFlag: false,
                fiscalTaxMarkList: [],
                invoiceTypeList: [],
                invoiceContentTagList: []
            }
        },
        created: function () {
            this.getFiscalTaxMarkList();

            let self = this;
            getMerchantBizParam("display.asset.related.info.in.trading", function (result) {
                self.showAssetInfo = Utils.isTrue(result);
            });
            getMerchantBizParam("asset.definition.create.alter.need.audit", function (result) {  // 新增/变更资产定义是否需要审核
                self.needAudit = Utils.isTrue(result);
            }, 0);
            // 发票类型
            let invoiceTypeList = getEnumList('invoiceType');
            for (let i = 0; i < invoiceTypeList.length; i++) {
                let invoiceType = invoiceTypeList[i];
                if (invoiceType.value == 0 || invoiceType.value == 3) {
                    invoiceTypeList.splice(i, 1);
                    i--;
                }
            }
            this.invoiceTypeList = Utils.merge([], invoiceTypeList);
            self.getContract();
        },
        methods: {
            filterListValue(listItems, listVal) {
                let listValues = listItems.pluck('rate')
                let reval = listValues.indexOf(listVal) == -1 ? null : listVal;
                return reval;
            },
            checkActionPerm: function (action) {
                return checkUserActionPerm(SwbGoodsPurchContractList.path, action, null);
            },
            inputWrntPeriod: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('请输入质保期'));
                } else {
                    if (!Utils.isNumber(value) || value < 0) {
                        callback(new Error('请输入整数'));
                    } else {
                        callback();
                    }
                }
            },
            // 获取合同信息
            getContract: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                let theLoad = MsgBox.loading();
                contractApi.getContractInfo(postData, function (result) {
                    theLoad.hide();
                    if (result.type == "info") {
                        let contract = result.data;
                        //
                        contract.taxRate = Utils.isNoB(contract.taxRate) ? 0.00 : parseFloat(contract.taxRate).toFixed(2);
                        let contractGoodsList = contract.contractGoodsList;
                        for (let i = 0; i < contractGoodsList.length; i++) {
                            let item = contractGoodsList[i];
                            let taxRate = item.taxRate;
                            if (Utils.isNoB(taxRate)) {
                                taxRate = 0.00;
                                item.ntxPrice = Utils.isNoB(item.price) ? 0.00 : parseFloat(item.price).toFixed(2);
                            } else {
                                taxRate = parseFloat(taxRate).toFixed(2);
                                if (Utils.isNoB(item.price)) {
                                    item.ntxPrice = null;
                                } else {
                                    item.ntxPrice = (parseFloat(item.price) / (1 + (parseFloat(taxRate) * 0.01))).toFixed(2);
                                }
                            }
                            item.taxRate = taxRate;
                            item.price = Utils.isNoB(item.price) ? 0.00 : parseFloat(item.price).toFixed(2);
                            item.amount = Utils.isNoB(item.amount) ? 0.00 : parseFloat(item.amount).toFixed(2);
                            //
                            let bizFormNames = item.bizFormNames;
                            if (!Utils.isNoB(bizFormNames)) {
                                let bizFormNameList = [];
                                if (!Utils.isNoB(bizFormNames)) {
                                    if (bizFormNames.indexOf("|") >= 0) {
                                        bizFormNames = bizFormNames.substring(1, bizFormNames.length - 1);
                                        bizFormNameList = bizFormNames.split("|") || [];
                                    }
                                }
                                item.bizFormNameList = bizFormNameList;
                            }
                        }
                        contract.contractGoodsList = Utils.merge([], contractGoodsList);
                        //
                        if (!Utils.isNoB(contract.estmtAmount)) {
                            contract.estmtAmount = parseFloat(contract.estmtAmount).toFixed(2);
                        }
                        self.contract = Utils.merge({}, contract);
                        self.dbContract = Utils.merge({}, contract);
                        // self.setGoodsAndServcAmount();
                        if (contract.kindId == 0) {
                            // 标准合同获取对应的实体公司的业务参数
                            getMerchantBizParam('asset.finac.enabled', function (normalFlagResult) {
                                self.normalFlag = Utils.isTrue(normalFlagResult);
                            }, 2, null, contract.fstPartyRealComId);
                        } else {
                            getMerchantBizParam('finac.mgmt.enabled', function (normalFlagResult) {
                                self.normalFlag = Utils.isTrue(normalFlagResult);
                            }, 0);
                        }
                        self.getInvoiceContentTagList();
                    }
                });
            },
            setGoodsAndServcAmount() {
                let self = this;
                //
                let goodsAmount = 0;
                let contractGoodsList = self.contract.contractGoodsList;
                for (let i = 0; i < contractGoodsList.length; i++) {
                    let quantity = contractGoodsList[i].quantity;
                    let price = contractGoodsList[i].price;
                    if (!Utils.isNoB(quantity)) {
                        if (!Utils.isInt(quantity) || quantity < 0) {
                            return;
                        }
                    }
                    if (!Utils.isNoB(price) && !Utils.isNoB(quantity)) {
                        goodsAmount += quantity * price;
                    }
                }
                self.goodsAmount = goodsAmount.toFixed(2);
            },
            // 启用区域价格
            bizAreaFlagChange: function (index) {
                //
                let contract = this.contract || {};
                let contractGoodsList = contract.contractGoodsList || [];
                if (!Utils.isNoB(index)) {
                    let bizAreaFlag = false;
                    for (let i = 0; i < contractGoodsList.length; i++) {
                        let contractGoods = contractGoodsList[i];
                        if (Utils.isTrue(contractGoods.bizAreaFlag)) {
                            bizAreaFlag = true;
                        }
                    }
                    contract.bizAreaFlag = bizAreaFlag;
                } else {
                    for (let i = 0; i < contractGoodsList.length; i++) {
                        let contractGoods = contractGoodsList[i];
                        contractGoods.bizAreaFlag = contract.bizAreaFlag;
                    }
                }
                //
                contract.contractGoodsList = Utils.merge([], contractGoodsList);
                this.contract = Utils.merge({}, contract);
            },
            // 选择商品
            showMkuListDlg: function () {
                let self = this;
                let contract = self.contract;
                let contractGoodsList = contract.contractGoodsList;
                let skuIds = [];
                if (contractGoodsList != null && contractGoodsList.length > 0) {
                    for (let i = 0; i < contractGoodsList.length; i++) {
                        skuIds.push(contractGoodsList[i].skuId);
                    }
                }
                let filter = {};
                filter.merchantId = contract.sndPartyId;
                filter.merchantType = self.goodsPurch.sndPartyType;
                filter.saleHalted = false
                openSkuListSelectDlg(true, filter, skuIds, function (data) {
                    let resultData = data;
                    if (resultData != null && resultData.length > 0) {
                        for (let i = 0; i < resultData.length > 0; i++) {
                            let sku = resultData[i];
                            if (sku.goodsId != null && sku.title != null) {
                                let item = {};
                                item.mkuId = sku.mkuId;
                                item.skuId = sku.id;
                                item.model = sku.model;
                                item.fixedSpec = sku.fixedSpec;
                                item.name = sku.title;
                                item.title = item.name || '' + sku.fixedSpec || '';
                                item.goodsId = sku.goodsId;
                                item.catId = sku.catId;
                                item.catName = sku.catName;
                                item.brandId = sku.brandId;
                                item.brandName = sku.brandName;
                                if (sku.priceNegoFlag) {
                                    item.price = null;
                                } else {
                                    item.price = Utils.isNoB(sku.salePrice) ? null : parseFloat(sku.salePrice).toFixed(2);
                                }
                                item.taxRate = contract.taxRate || 0.00;
                                if (Utils.isNoB(item.price)) {
                                    item.ntxPrice = item.price;
                                } else {
                                    item.ntxPrice = (parseFloat(item.price) / (1 + (parseFloat(item.taxRate) * 0.01))).toFixed(2);
                                }
                                item.bizAreaFlag = contract.bizAreaFlag;
                                item.wrntPeriod = sku.wrntPeriod;
                                item.unit = sku.unit;
                                item.fileBrowseUrl = sku.defaultImageUrl;
                                if (item.asmblAccFlag) {
                                    item.customized = false;
                                    item.customizable = false;
                                } else {
                                    item.customized = sku.customized;
                                    item.customizable = sku.customized;
                                }
                                item.taxOffset = Utils.isTrue(contract.taxOffset);
                                contractGoodsList.push(item);
                            }
                        }
                        self.sortContractGoods(contractGoodsList);
                        self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                    }
                });
            },
            // 商品排序
            sortContractGoods: function (contractGoodsList) {
                contractGoodsList = contractGoodsList || [];
                for (let i = 0; i < contractGoodsList.length > 0; i++) {
                    let contractGoods = contractGoodsList[i];
                    contractGoods.seqNo = i + 1;
                }
            },
            selectDevcDef: function (row, index) {
                let self = this;
                let contract = self.contract || {};
                let contractGoodsList = contract.contractGoodsList || [];
                //
                let devcDefIds = [];
                let accDefIds = [];
                for (let i = 0; i < contractGoodsList.length; i++) {
                    let contractGoods = contractGoodsList[i];
                    let assetDefId = contractGoods.assetDefId;
                    if (!Utils.isNoB(assetDefId) && assetDefId != -1) {
                        if (Utils.isTrue(contractGoods.asmblAccFlag)) {
                            if (!accDefIds.contains(assetDefId)) {
                                accDefIds.push(assetDefId)
                            }
                        } else {
                            if (!devcDefIds.contains(assetDefId)) {
                                devcDefIds.push(assetDefId)
                            }
                        }
                    }
                }
                //
                let assetDefId = row.assetDefId;
                if (row.asmblAccFlag) {
                    let checkIds = [];
                    if (!Utils.isNoB(assetDefId) && assetDefId != -1) {
                        checkIds.push(assetDefId)
                    }
                    showAsmblAccDefSelectDlg({
                        filter: {
                            vendorIdX: contract.sndPartyId,
                            queryOneAdoptedDevice: true // 查询一个入选商品
                        },
                        checkBox: false,
                        checkIds: checkIds,
                        needDisabled: true
                    }, function (devcDef, dlg) {
                        if (accDefIds.contains(devcDef.id) && row.assetDefId != devcDef.id) {
                            MsgBox.warning("商品信息中已包含该定义，请更换其他定义");
                            return;
                        }
                        dlg.close();
                        self.makeContractGoodsInfo(row, devcDef, contract);
                        self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                    });
                } else {
                    let selectIds = [];
                    if (!Utils.isNoB(assetDefId) && assetDefId != -1) {
                        selectIds.push(assetDefId)
                    }
                    showMerchtDevcDefSelectDlg({
                        catId: row.catId,
                        brandId: row.brandId,
                        modelSpec: row.shortSpec,
                        normalized: self.normalFlag,
                        selectIds: selectIds,
                        filter: {
                            vendorIdX: contract.sndPartyId,
                            purchFlag: Utils.isTrue(self.normalFlag) ? true : null,
                            queryOneAdoptedDevice: true // 查询一个入选商品
                        }
                    }, function (devcDef, dlg) {
                        if (devcDefIds.contains(devcDef.id) && row.assetDefId != devcDef.id) {
                            MsgBox.warning("商品信息中已包含该定义，请更换其他定义");
                            return;
                        }
                        dlg.close();
                        self.makeContractGoodsInfo(row, devcDef, contract);
                        self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                    });
                }
            },
            // 选择资产定义，只能选择可采购的定义
            showDevcDefListDlg: function () {
                let self = this;
                let contract = self.contract || {};
                let contractGoodsList = contract.contractGoodsList || [];
                let selectIds = [];
                for (let i = 0; i < contractGoodsList.length; i++) {
                    let contractGoods = contractGoodsList[i];
                    let assetDefId = contractGoods.assetDefId;
                    if (!Utils.isNoB(assetDefId) && assetDefId != -1 && !Utils.isTrue(contractGoods.asmblAccFlag)) {
                        if (!selectIds.contains(assetDefId)) {
                            selectIds.push(assetDefId)
                        }
                    }
                }
                showMerchtDevcDefSelectDlg({
                    checkBox: true,
                    normalized: Utils.isTrue(self.normalFlag) ? true : null,
                    selectIds: selectIds,
                    filter: {
                        purchFlag: true,
                        disabled: false,
                        vendorIdX: contract.sndPartyId,
                        queryOneAdoptedDevice: true // 查询一个入选商品
                    }
                }, function (devcDefs, dlg) {
                    dlg.close();
                    devcDefs = devcDefs || [];
                    let goodsList = [];
                    for (let i = 0; i < devcDefs.length; i++) {
                        let devcDef = devcDefs[i];
                        let goodsInfo = {};
                        goodsInfo.asmblAccFlag = false;
                        self.makeContractGoodsInfo(goodsInfo, devcDef, contract);
                        goodsList.push(goodsInfo);
                    }
                    contractGoodsList = contractGoodsList.concat(goodsList);
                    self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                });
            },
            saveDevcDef: function (row, index) {
                let self = this;
                let contractGoodsList = self.contract.contractGoodsList || [];
                let brandId = row.brandId == null ? -1 : row.brandId;
                let devcDef = {};
                devcDef.name = row.title;
                devcDef.model = row.model;
                devcDef.fixedSpec = row.fixedSpec;
                devcDef.theUnit = row.unit;
                devcDef.catId = row.catId;
                devcDef.catName = row.catName;
                devcDef.brandId = brandId;
                devcDef.brandName = row.brandName;
                devcDef.createDef = true;

                if (row.asmblAccFlag) {
                    devcDef.centBuyMode = false;
                    openAccDefSaveDlg({
                        row: devcDef,
                        buildFlag: true,
                        realDevcDef: true
                    }, function (result, theDlg) {
                        theDlg.close();
                        let postData = result;
                        postData.assetType = 3;
                        postData.createFlag = true;
                        let msgBoxDlg = MsgBox.loading();
                        asmblAccApi.getAsmblAccDefByUK(postData, function (result1) {
                            msgBoxDlg.close();
                            if (result1.type == 'info') {
                                let accDef = result1.data;
                                row.assetDefId = accDef.id;
                                row.assetDefNo = accDef.innerCode;
                                row.title = accDef.title;
                                row.devcName = accDef.name;
                                row.devcCatId = accDef.catId;
                                row.devcCatName = accDef.catName;
                                row.devcBrandId = accDef.brandId;
                                row.devcBrandName = accDef.brandName;
                                row.devcModel = accDef.model;
                                row.devcFixedSpec = accDef.fixedSpec;
                                row.devcUnit = accDef.theUnit;
                                devcDefApi.doSaveMerchtDevcDefRel({
                                    devcDefId: accDef.assetDefId,
                                    merchtDevcAccAsmblRelList: [{
                                        accDefId: accDef.id,
                                        accDefTitle: accDef.title,
                                        count: 1
                                    }]
                                }, function (result2) {
                                    if (result2.type === "info") {

                                    } else {
                                        MsgBox.warning(result2.message);
                                    }
                                });
                                self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                            } else {
                                MsgBox.warning(result1.message);
                            }
                        });
                    });
                } else {
                    devcDef.purchFlag = true;
                    devcDef.centBuyRequired = false;
                    devcDef.vendorUknoFlag = false;
                    devcDef.setupFlag = false;
                    devcDef.asmblFlag = false;
                    devcDef.asmblWhileSetup = false;
                    devcDef.stockFifo = false;
                    devcDef.assetType = 0;
                    let params = {
                        row: devcDef,
                        assetTypeDisabled: true,
                        normalized: Utils.isTrue(self.normalFlag)
                    };
                    openDevcDefSaveDlg(params, function (result, theDlg) {
                        theDlg.close();
                        let postData = result;
                        postData.createFlag = true;
                        postData.normalized = Utils.isTrue(self.normalFlag);
                        let msgBoxDlg = MsgBox.loading();
                        devcDefApi.getMerchtDevcDefInfoByUK(postData, function (result) {
                            msgBoxDlg.close();
                            if (result.type == 'info') {
                                let devcDef = result.data;
                                row.assetDefId = devcDef.id;
                                row.assetDefNo = devcDef.innerCode;
                                row.title = devcDef.title;
                                row.devcName = devcDef.name;
                                row.devcCatId = devcDef.innerDevcCatId;
                                row.devcCatName = devcDef.innerDevcCatName;
                                row.devcBrandId = devcDef.innerDevcBrandId;
                                row.devcBrandName = devcDef.innerDevcBrandName;
                                row.devcModel = devcDef.model;
                                row.devcFixedSpec = devcDef.fixedSpec;
                                row.devcUnit = devcDef.theUnit;
                                self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    });
                }
            },
            clearDevcDef: function (row, index, clearAsmblAccFlag) {
                let self = this;
                let contractGoodsList = self.contract.contractGoodsList || [];
                if (row.assetDefId != null && row.assetDefId != -1) {
                    row.assetDefId = null;
                    row.assetDefNo = null;
                    row.devcName = null;
                    row.devcCatId = null;
                    row.devcCatName = null;
                    row.devcBrandId = null;
                    row.devcBrandName = null;
                    row.devcModel = null;
                    row.devcFixedSpec = null;
                    row.devcUnit = null;
                    row.customized = false;
                    if (Utils.isTrue(clearAsmblAccFlag)) {
                        row.asmblAccFlag = false;
                    }
                    self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                }
            },
            // 选择组装件定义
            showAsmblAccListDlg: function () {
                let self = this;
                let contract = self.contract || {};
                let contractGoodsList = contract.contractGoodsList || [];
                let selectIds = [];
                for (let i = 0; i < contractGoodsList.length; i++) {
                    let contractGoods = contractGoodsList[i];
                    let assetDefId = contractGoods.assetDefId;
                    if (!Utils.isNoB(assetDefId) && assetDefId != -1 && Utils.isTrue(contractGoods.asmblAccFlag)) {
                        if (!selectIds.contains(assetDefId)) {
                            selectIds.push(assetDefId)
                        }
                    }
                }
                showAsmblAccDefSelectDlg({
                    filter: {
                        vendorIdX: contract.sndPartyId,
                        queryOneAdoptedDevice: true // 查询一个入选商品
                    },
                    checkBox: true,
                    checkIds: selectIds,
                    needDisabled: true
                }, function (devcDefs, dlg) {
                    dlg.close();
                    devcDefs = devcDefs || [];
                    let goodsList = [];
                    for (let i = 0; i < devcDefs.length; i++) {
                        let devcDef = devcDefs[i];
                        let goodsInfo = {};
                        goodsInfo.asmblAccFlag = true;
                        self.makeContractGoodsInfo(goodsInfo, devcDef, contract);
                        goodsList.push(goodsInfo);
                    }
                    contractGoodsList = contractGoodsList.concat(goodsList);
                    self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                });
            },
            // 组装合同商品信息
            makeContractGoodsInfo: function (contractGoods, assetDef, contract) {
                contractGoods.assetDefId = assetDef.id;
                contractGoods.assetDefNo = assetDef.innerCode;
                contractGoods.title = assetDef.title;
                contractGoods.devcName = assetDef.name;
                if (Utils.isTrue(contractGoods.asmblAccFlag)) {
                    contractGoods.devcCatId = assetDef.catId;
                    contractGoods.devcCatName = assetDef.catName;
                    contractGoods.devcBrandId = assetDef.brandId;
                    contractGoods.devcBrandName = assetDef.brandName;
                } else {
                    contractGoods.devcCatId = assetDef.innerDevcCatId;
                    contractGoods.devcCatName = assetDef.innerDevcCatName;
                    contractGoods.devcBrandId = assetDef.innerDevcBrandId;
                    contractGoods.devcBrandName = assetDef.innerDevcBrandName;
                }
                contractGoods.devcModel = assetDef.model;
                contractGoods.devcFixedSpec = assetDef.fixedSpec;
                contractGoods.devcUnit = assetDef.theUnit;
                contractGoods.taxRate = contract.taxRate || 0.00;
                contractGoods.taxOffset = Utils.isTrue(contract.taxOffset);
                contractGoods.bizAreaFlag = contract.bizAreaFlag;
                let adoptedDevice = assetDef.adoptedDevice || {};
                if (!Utils.isNoB(adoptedDevice) && adoptedDevice.id > 0 && (contract.creatorComId == contract.fstPartyComId)) {
                    contractGoods.adoptedDeviceId = adoptedDevice.id;
                    contractGoods.skuId = adoptedDevice.skuId;
                    contractGoods.model = adoptedDevice.model;
                    contractGoods.fixedSpec = adoptedDevice.fixedSpec;
                    contractGoods.name = adoptedDevice.title;
                    contractGoods.title = contractGoods.name || '' + adoptedDevice.fixedSpec || '';
                    contractGoods.goodsId = adoptedDevice.goodsId;
                    contractGoods.catId = adoptedDevice.goodsCatId;
                    contractGoods.catName = adoptedDevice.goodsCatName;
                    contractGoods.brandId = adoptedDevice.goodsBrandId;
                    contractGoods.brandName = adoptedDevice.goodsBrandName;
                    contractGoods.price = Utils.isNoB(adoptedDevice.price) ? null : parseFloat(adoptedDevice.price).toFixed(2);
                    if (Utils.isNoB(contractGoods.price)) {
                        contractGoods.ntxPrice = contractGoods.price;
                    } else {
                        contractGoods.ntxPrice = (parseFloat(contractGoods.price) / (1 + (parseFloat(contractGoods.taxRate) * 0.01))).toFixed(2);
                    }
                    contractGoods.customized = adoptedDevice.customizable;
                    contractGoods.customizable = Utils.isTrue(adoptedDevice.customizable);
                    contractGoods.wrntPeriod = adoptedDevice.wrntPeriod;
                    contractGoods.unit = adoptedDevice.unit;
                }
            },
            setAsmblAcc(row, index) {
                if (!Utils.isNoB(row.assetDefId)) {
                    this.clearDevcDef(row, index, false);
                }
            },
            // 含税金额校验
            goodsAmountOrQuantityChange: function (item, index, changeFlag) {
                let self = this;
                let goodsAmount = 0;
                let estmtGoodsCount = 0;
                let contractGoodsList = self.contract.contractGoodsList;
                for (let i = 0; i < contractGoodsList.length; i++) {
                    let quantity = contractGoodsList[i].quantity;
                    let price = contractGoodsList[i].price;
                    if (i == index && changeFlag == 'quantity') {
                        if (Utils.isNoB(quantity)) {
                            MsgBox.warning("请输入商品数量！");
                        } else if (!Utils.isInt(quantity) || quantity < 0) {
                            MsgBox.warning("只能输入大于0的整数！");
                            quantity = null;
                        } else {
                            contractGoodsList[i].amount = ((Utils.isNoB(price) ? 0 : parseFloat(price)) * parseInt(quantity)).toFixed(2);
                        }
                    }
                    if (i == index && changeFlag == 'price') {
                        if (Utils.isNoB(price)) {
                            MsgBox.warning("请输入金额！");
                            price = null;
                        } else if (!Utils.isMoneyStr(price)) {
                            MsgBox.warning("请输入正确的金额！");
                            price = null;
                        }
                        // 未税价格
                        if (!Utils.isNoB(price)) {
                            let taxRate = contractGoodsList[i].taxRate || 0;
                            contractGoodsList[i].ntxPrice = (parseFloat(price) / (1 + (parseFloat(taxRate) * 0.01))).toFixed(2);
                            contractGoodsList[i].amount = ((Utils.isNoB(quantity) ? 0 : parseInt(quantity)) * parseFloat(price)).toFixed(2);
                        } else {
                            contractGoodsList[i].ntxPrice = null;
                        }
                    }
                    if (!Utils.isNoB(quantity)) {
                        estmtGoodsCount += quantity;
                    }
                    if (!Utils.isNoB(price) && !Utils.isNoB(quantity)) {
                        let amount = contractGoodsList[i].amount;
                        if (!Utils.isNoB(amount)) {
                            goodsAmount += parseFloat(amount);
                        }
                    }
                    contractGoodsList[i].quantity = quantity;
                    contractGoodsList[i].price = Utils.isNoB(price) ? null : parseFloat(price).toFixed(2);
                    contractGoodsList[i].amount = Utils.isNoB(contractGoodsList[i].amount) ? 0.00 : parseFloat(contractGoodsList[i].amount).toFixed(2);
                }
                //
                self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                //
                self.goodsAmount = goodsAmount.toFixed(2);
                self.contract.estmtAmount = ParseFloat(self.goodsAmount) + ParseFloat(self.servcAmount);
                self.contract.estmtGoodsCount = estmtGoodsCount;
            },
            //
            removeGoods: function (index) {
                let self = this;
                let contractGoodsList = self.contract.contractGoodsList;
                for (let i = 0; i < contractGoodsList.length; i++) {
                    if (i == index) {
                        contractGoodsList.remove(contractGoodsList[i]);
                    }
                }
                self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                //
                self.goodsAmountOrQuantityChange();
            },
            // 设置经营区域价格
            bizAreaOption: function (row, index) {
                let self = this;
                let params = {
                    disabled: self.disabled,
                    taxRate: self.contract.taxRate,
                    areaPrices: row.contractGoodsAreaPrices || [],
                    bizFormNameList: row.bizFormNameList || [],
                    kindId: self.contract.kindId,
                    price: row.price
                };
                openContractGoodsAreaPriceDlg(params, function (areaPriceList, theDlg) {
                    theDlg.close();
                    areaPriceList = areaPriceList || [];
                    row.contractGoodsAreaPrices = areaPriceList;
                    if (self.contract.kindId != null && self.contract.kindId == 0) {
                        let quantity = 0;
                        let amount = 0;
                        for (let i = 0; i < areaPriceList.length; i++) {
                            let areaPrice = areaPriceList[i];
                            quantity = quantity + parseInt(areaPrice.quantity);
                            amount = amount + parseFloat(areaPrice.amount);
                        }
                        row.quantity = quantity;
                        row.amount = amount.toFixed(2);
                    }
                    //
                    let estmtGoodsCount = 0;
                    let goodsAmount = 0;
                    let contractGoodsList = self.contract.contractGoodsList || [];
                    for (let i = 0; i < contractGoodsList.length; i++) {
                        if (i == index) {
                            contractGoodsList[i] = row;
                        }
                        if (self.contract.kindId != null && self.contract.kindId == 0) {
                            estmtGoodsCount = estmtGoodsCount + parseInt(Utils.isNoB(contractGoodsList[i].quantity) ? 0 : contractGoodsList[i].quantity);
                            goodsAmount = goodsAmount + parseFloat(Utils.isNoB(contractGoodsList[i].amount) ? 0 : contractGoodsList[i].amount);
                        }
                    }
                    self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                    //
                    if (self.contract.kindId != null && self.contract.kindId == 0) {
                        self.goodsAmount = goodsAmount.toFixed(2);
                        self.contract.estmtAmount = ParseFloat(self.goodsAmount) + ParseFloat(self.servcAmount);
                        self.contract.estmtGoodsCount = estmtGoodsCount;
                    }
                });
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            // 批量设置经营业态
            setBizFormBatch: function () {
                let self = this;
                let multipleSelection = this.multipleSelection;
                if (multipleSelection == null || multipleSelection.length <= 0) {
                    MsgBox.warning('请选择要设置的数据');
                    return;
                }
                //
                let checkedIds = [];
                let params = {
                    checkedIds: checkedIds,
                    isShowSelection: true
                };
                openBizFormSelectionDlg(params, function (bizFormList, theDlg) {
                    //
                    bizFormList = bizFormList || [];
                    if (bizFormList.length > 5) {
                        MsgBox.warning('最多可设置5个经营业态！');
                        return;
                    }
                    theDlg.close();
                    let bizFormIds = '';
                    let bizFormNames = '';
                    for (let i = 0; i < bizFormList.length; i++) {
                        let bizForm = bizFormList[i];
                        if (bizFormIds.length <= 0) {
                            bizFormIds = '|' + bizForm.id + '|';
                            bizFormNames = '|' + bizForm.name + '|';
                        } else {
                            bizFormIds += bizForm.id + '|';
                            bizFormNames += bizForm.name + '|';
                        }
                    }
                    //
                    multipleSelection.forEach(function (item) {
                        item.bizFormIds = bizFormIds;
                        item.bizFormNames = bizFormNames;
                        if (!Utils.isNoB(bizFormNames)) {
                            let bizFormNameStr = bizFormNames;
                            let bizFormNameList = [];
                            if (!Utils.isNoB(bizFormNameStr)) {
                                if (bizFormNameStr.indexOf('|') >= 0) {
                                    bizFormNameStr = bizFormNameStr.substring(1, bizFormNameStr.length - 1);
                                    bizFormNameList = bizFormNameStr.split('|') || [];
                                }
                            }
                            item.bizFormNameList = bizFormNameList;
                        } else {
                            item.bizFormNameList = [];
                        }
                    });
                    self.contract = Utils.merge({}, self.contract);
                });
            },
            // 设置经营业态
            setBizForm: function (row, index) {
                let self = this;
                let bizFormIdStr = row.bizFormIds;
                let checkedIds = [];
                if (!Utils.isNoB(bizFormIdStr)) {
                    if (bizFormIdStr.indexOf("|") >= 0) {
                        bizFormIdStr = bizFormIdStr.substring(1, bizFormIdStr.length - 1);
                        checkedIds = bizFormIdStr.split("|") || [];
                    }
                }
                let params = {
                    checkedIds: checkedIds,
                    isShowSelection: true
                };
                openBizFormSelectionDlg(params, function (bizFormList, theDlg) {
                    //
                    bizFormList = bizFormList || [];
                    if (bizFormList.length > 5) {
                        MsgBox.warning("最多可设置5个经营业态！");
                        return;
                    }
                    theDlg.close();
                    let bizFormIds = '';
                    let bizFormNames = '';
                    for (let i = 0; i < bizFormList.length; i++) {
                        let bizForm = bizFormList[i];
                        if (bizFormIds.length <= 0) {
                            bizFormIds = '|' + bizForm.id + '|';
                            bizFormNames = '|' + bizForm.name + '|';
                        } else {
                            bizFormIds += bizForm.id + '|';
                            bizFormNames += bizForm.name + '|';
                        }
                    }
                    //
                    let contractGoodsList = self.contract.contractGoodsList || [];
                    for (let i = 0; i < contractGoodsList.length; i++) {
                        let contractGoods = contractGoodsList[i];
                        if (i == index) {
                            contractGoods.bizFormIds = bizFormIds;
                            contractGoods.bizFormNames = bizFormNames;
                            if (!Utils.isNoB(bizFormNames)) {
                                let bizFormNameList = [];
                                if (!Utils.isNoB(bizFormNames)) {
                                    if (bizFormNames.indexOf("|") >= 0) {
                                        bizFormNames = bizFormNames.substring(1, bizFormNames.length - 1);
                                        bizFormNameList = bizFormNames.split("|") || [];
                                    }
                                }
                                contractGoods.bizFormNameList = bizFormNameList;
                            } else {
                                contractGoods.bizFormNameList = [];
                            }
                        }
                    }
                    self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                });
            },
            // 选择/更换入选商品信息
            selectAdoptedDevice: function (row, index) {
                let self = this;
                //
                let assetDefId = row.assetDefId;
                if (assetDefId == -1) {
                    assetDefId = null;
                }
                if (Utils.isNoB(assetDefId)) {
                    MsgBox.warning("请选择定义！");
                    return;
                }
                //
                let contract = self.contract || {};
                let contractGoodsList = contract.contractGoodsList || [];
                let FrameVal = getEnumInfoWith("contractKind", "name", "Frame").value;
                if (Utils.isNoB(row.id) && contract.kindId == FrameVal) {
                    let filter = {};
                    filter.merchantId = contract.sndPartyId;
                    filter.merchantType = self.goodsPurch.sndPartyType;
                    filter.saleHalted = false;
                    openSkuListSelectDlg(false, filter, null, function (data) {
                        let sku = data;
                        if (sku != null && sku.id > 0) {
                            if (sku.goodsId != null && sku.title != null) {
                                row.mkuId = sku.mkuId;
                                row.skuId = sku.id;
                                row.model = sku.model;
                                row.fixedSpec = sku.fixedSpec;
                                row.name = sku.title;
                                row.title = row.name || '' + sku.fixedSpec || '';
                                row.goodsId = sku.goodsId;
                                row.catId = sku.catId;
                                row.catName = sku.catName;
                                row.brandId = sku.brandId;
                                row.brandName = sku.brandName;
                                if (sku.priceNegoFlag) {
                                    row.price = null;
                                } else {
                                    row.price = Utils.isNoB(sku.salePrice) ? null : parseFloat(sku.salePrice).toFixed(2);
                                }
                                row.taxRate = contract.taxRate || 0.00;
                                if (Utils.isNoB(row.price)) {
                                    row.ntxPrice = row.price;
                                } else {
                                    row.ntxPrice = (parseFloat(row.price) / (1 + (parseFloat(row.taxRate) * 0.01))).toFixed(2);
                                }
                                row.bizAreaFlag = contract.bizAreaFlag;
                                row.wrntPeriod = sku.wrntPeriod;
                                row.unit = sku.unit;
                                row.fileBrowseUrl = sku.defaultImageUrl;
                                if (row.asmblAccFlag) {
                                    row.customized = false;
                                } else {
                                    row.customized = sku.customized;
                                }
                                row.taxOffset = Utils.isTrue(contract.taxOffset);
                                //
                                contractGoodsList[index] = Utils.merge({}, row);
                                contract.contractGoodsList = Utils.merge([], contractGoodsList);
                                self.contract = Utils.merge({}, contract);
                            }
                        }
                    });
                } else {
                    //
                    let sndPartyId = contract.sndPartyId;
                    if (!Utils.isNoB(sndPartyId) && sndPartyId == -1) {
                        sndPartyId = null;
                    }
                    //
                    let filter = {
                        asmblAccFlag: row.asmblAccFlag,
                        assetDefId: assetDefId,
                        vendorId: sndPartyId,
                        disabled: false
                    };
                    let checkIds = [];
                    if (Utils.isNoB(row.adoptedDeviceId)) {
                        checkIds.push(row.adoptedDeviceId);
                    }
                    //
                    let params = {};
                    params.filter = filter;
                    params.skuFlag = true;
                    params.checkBox = false;
                    params.showTable = false;
                    params.checkIds = checkIds;
                    goodsInSelectDlg(params, function (adoptedDevice) {
                        row.adoptedDeviceId = adoptedDevice.id;
                        row.skuId = adoptedDevice.skuId;
                        row.model = adoptedDevice.model;
                        row.fixedSpec = adoptedDevice.fixedSpec;
                        row.name = adoptedDevice.title;
                        row.title = row.name || '' + adoptedDevice.fixedSpec || '';
                        row.goodsId = adoptedDevice.goodsId;
                        row.catId = adoptedDevice.goodsCatId;
                        row.catName = adoptedDevice.goodsCatName;
                        row.brandId = adoptedDevice.goodsBrandId;
                        row.brandName = adoptedDevice.goodsBrandName;
                        row.price = Utils.isNoB(adoptedDevice.price) ? null : parseFloat(adoptedDevice.price).toFixed(2);
                        row.taxRate = contract.taxRate || 0.00;
                        if (Utils.isNoB(row.price)) {
                            row.ntxPrice = row.price;
                        } else {
                            row.ntxPrice = (parseFloat(row.price) / (1 + (parseFloat(row.taxRate) * 0.01))).toFixed(2);
                        }
                        row.bizAreaFlag = contract.bizAreaFlag;
                        row.wrntPeriod = adoptedDevice.wrntPeriod;
                        row.unit = adoptedDevice.unit;
                        row.taxOffset = Utils.isTrue(contract.taxOffset);
                        //
                        contractGoodsList[index] = Utils.merge({}, row);
                        contract.contractGoodsList = Utils.merge([], contractGoodsList);
                        self.contract = Utils.merge({}, contract);
                    });
                }
            },
            getFiscalTaxMarkList: function () {
                let self = this;
                let postData = {};
                postData.disabled = false;
                postData.type = getEnumInfoWith('taxType', 'name', 'JXS').value;
                postData.sysBizLineId = 1;  // 资产税码
                let theLoad = MsgBox.loading();
                fiscalBizApi.getSyncFiscalTaxMarkPageList(postData, function (result) {
                    theLoad.hide();
                    if (result.type === 'info') {
                        let fiscalTaxMarkList = result.data || [];
                        if (fiscalTaxMarkList.length > 0) {
                            fiscalTaxMarkList.forEach(function (item) {
                                item.rate = parseFloat(item.rate).toFixed(2)
                            })
                        }
                        self.fiscalTaxMarkList = fiscalTaxMarkList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 税率变化事件
            taxRateChange: function (taxRate) {
                if (!Utils.isNoB(taxRate)) {
                    if (!Utils.isMoneyStr(taxRate)) {
                        taxRate = null;
                    } else {
                        let taxRateF = parseFloat(taxRate);
                        if (taxRateF > 100) {
                            taxRate = null;
                        } else {
                            taxRate = taxRateF.toFixed(2);
                        }
                    }
                }
                //
                let contract = this.contract || {};
                contract.taxRate = taxRate;
                let contractGoodsList = contract.contractGoodsList || [];
                for (let i = 0; i < contractGoodsList.length; i++) {
                    let item = contractGoodsList[i];
                    //
                    item.taxRate = taxRate;
                    if (Utils.isNoB(taxRate) || Utils.isNoB(item.price)) {
                        item.ntxPrice = item.price;
                    } else {
                        item.ntxPrice = (parseFloat(item.price) / (1 + (parseFloat(taxRate) * 0.01))).toFixed(2);
                    }
                }
                contract.contractGoodsList = Utils.merge([], contractGoodsList);
                this.contract = Utils.merge({}, contract);
            },
            // 常用发票
            selectInvoiceSubject: function () {
                let self = this;
                if (Utils.isNoB(self.contract.invoiceType)) {
                    MsgBox.warning('未确定发票类型');
                    return;
                }
                let params = {
                    showAddFlag: true,
                    buyerRealComId: self.contract.fstPartyRealComId,
                    invoiceType: self.contract.invoiceType
                };
                selectInvoiceSubjectDlg(params, function (resultData, theDlag) {
                    theDlag.close();
                    self.contract.invoiceTitle = resultData.invoiceTitle;
                    self.contract.taxPayerNo = resultData.taxPayerNo;
                    //self.contract.invoiceContentTag = data.invoiceContentTag;
                    self.contract = Utils.merge({}, self.contract);
                })
            },
            checkInvoiceType: function (value) {
                this.contract.invoiceType = value;
                if (!Utils.isNoB(value) && !Utils.isNoB(this.contract.fstPartyRealComId)) {
                    this.getTaxOffSetVal(value);
                }
                //
                this.getMerchantInvoiceSubjectByOnly();
            },
            getTaxOffSetVal: function (invoiceType) {
                let self = this;
                let params = {
                    invoiceType: invoiceType,
                    realComId: self.contract.fstPartyRealComId
                };
                merchtComnApi.getTaxDeductible(params, function (result) {
                    if (result.type == 'info') {
                        let data = result.data;
                        //
                        let contract = self.contract || {};
                        contract.taxOffset = Utils.isTrue(data);
                        //
                        let contractGoodsList = contract.contractGoodsList || [];
                        let len = contractGoodsList.length;
                        if (len > 0) {
                            for (let i = 0; i < len; i++) {
                                let contractGoods = contractGoodsList[i];
                                contractGoods.taxOffset = contract.taxOffset;
                            }
                            contract.contractGoodsList = Utils.merge([], contractGoodsList);
                        }
                        //
                        self.contract = Utils.merge({}, contract);
                    }
                });
            },
            getMerchantInvoiceSubjectByOnly: function () {
                let self = this;
                let postData = {};
                postData.realComId = self.contract.fstPartyRealComId;
                postData.invoiceType = self.contract.invoiceType;
                merchtFinacApi.getMerchantInvoiceSubjectList(postData, function (result) {
                    if (result.type == 'info') {
                        let invoiceSubjectList = Utils.merge([], result.data);
                        if (invoiceSubjectList.length > 0) {
                            let invoiceSubjectInfo = null;
                            for (let i = 0; i < invoiceSubjectList.length; i++) {
                                if (Utils.isTrue(invoiceSubjectList[i].defaulted)) {
                                    invoiceSubjectInfo = invoiceSubjectList[i];
                                    break;
                                }
                            }
                            self.contract.invoiceTitle = invoiceSubjectInfo.invoiceTitle;
                            self.contract.taxPayerNo = invoiceSubjectInfo.taxPayerNo;
                            //self.contract.invoiceContentTag = data.invoiceContentTag;
                            self.contract = Utils.merge({}, self.contract);
                        } else {
                            self.contract.invoiceTitle = null;
                            self.contract.taxPayerNo = null;
                            //self.contract.invoiceContentTag = null;
                            self.contract = Utils.merge({}, self.contract);
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getInvoiceContentTagList: function () {
                let self = this;
                let postData = {};
                postData.merchantRealId = self.contract.sndPartyRealId;
                postData.realComId = self.contract.sndPartyRealComId;
                postData.merchantType = self.goodsPurch.sndPartyType;
                merchtFinacApi.getMerchantInvoiceCtntTagList(postData, function (result) {
                    if (result.type == 'info') {
                        if (result.data != null && result.data.length > 0) {
                            self.invoiceContentTagList = result.data;
                        }
                    }
                });
            },
            checkinvoiceContentTag: function (name) {
                let self = this;
                self.contract.invoiceContentTag = name;
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                let contract = this.contract || {};
                //
                if (Utils.isTrue(this.normalFlag)) {
                    if (Utils.isNoB(contract.taxRate)) {
                        MsgBox.warning("请输入税率，大于等于0的数！");
                        return;
                    } else {
                        if (!Utils.isMoneyStr(contract.taxRate)) {
                            MsgBox.warning("请输入正确的税率！");
                            return;
                        } else {
                            let taxRate = parseFloat(contract.taxRate);
                            if (taxRate > 100) {
                                MsgBox.warning("税率不能超过100！");
                                return;
                            }
                        }
                    }
                }
                if (Utils.isNoB(contract.invoiceType)) {
                    MsgBox.warning("发票信息[发票类型]不可为空");
                    return;
                }
                if (Utils.isNoB(contract.taxPayerNo)) {
                    MsgBox.warning("发票信息[纳税人识别号]不可为空");
                    return;
                }
                //
                if (contract.contractGoodsList.length == 0) {
                    MsgBox.warning("无商品信息！");
                    return;
                }
                let contractGoodsList = contract.contractGoodsList || [];
                let errFlag = false;
                for (let i = 0; i < contractGoodsList.length; i++) {
                    let contractGoods = contractGoodsList[i];
                    if (Utils.isTrue(self.showAssetInfo) && (contractGoods.assetDefId == null || contractGoods.assetDefId == -1)) {
                        MsgBox.warning("请为商品【" + contractGoods.title + "】关联定义！");
                        errFlag = true;
                        break;
                    }
                    if (Utils.isTrue(self.showAssetInfo) && (Utils.isNoB(contractGoods.skuId) || contractGoods.skuId == -1)) {
                        MsgBox.warning("请为已选择定义[" + contractGoods.assetDefNo + "]的行选择商品！");
                        errFlag = true;
                        break;
                    }
                    if (Utils.isTrue(contractGoods.bizAreaFlag)) {
                        let contractGoodsAreaPrices = contractGoods.contractGoodsAreaPrices || [];
                        if (contractGoodsAreaPrices.length <= 0) {
                            MsgBox.warning("请为商品【" + contractGoods.title + "】设置区域价格！");
                            errFlag = true;
                            break;
                        }
                    } else {
                        let quantity = contractGoods.quantity;
                        if (Utils.isNoB(quantity) && !Utils.isNoB(self.contract.kindId) && self.contract.kindId == 0) {
                            MsgBox.warning("请为商品【" + contractGoods.title + "】设置具体的商品数量！");
                            errFlag = true;
                            break;
                        }
                        let price = contractGoods.price;
                        if (Utils.isNoB(price) || parseFloat(price) <= 0) {
                            MsgBox.warning("请为商品【" + contractGoods.title + "】设置具体的含税价！");
                            errFlag = true;
                            break;
                        }
                    }
                }
                if (Utils.isTrue(errFlag)) {
                    return;
                }
                if (!Utils.isNoB(self.contract.kindId) && self.contract.kindId == 0) {
                    if (Utils.isNoB(contract.estmtAmount) || !Utils.isMoneyStr(contract.estmtAmount) || contract.estmtAmount < 0) {
                        MsgBox.warning("请输入正确的预计合同总额！");
                        return;
                    }
                }
                if (contract.estmtAmount == null) {
                    contract.estmtAmount = 0;
                }
                if (Utils.obj_val_equal(self.dbContract, contract, true, [])) {
                    // 没有变化，无需保存
                    MsgBox.warning("没有修订任何信息，无需进行此操作！");
                    return;
                }
                result.type = "info";
                result.data = Utils.merge({}, contract);
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/contract/ContractModify.vue